import type { AxiosResponse, AxiosStatic } from 'axios';
import type { GetResponse, GetRoutePaths, PostResponse, PostRoutePaths, PostRouteRequest, Tail } from './types';

class ServerCaller {
  private axios: AxiosStatic;

  constructor(axios: AxiosStatic) {
    this.axios = axios;
  }

  async get<T extends GetRoutePaths>(
    path: T,
    ...args: Tail<Parameters<AxiosStatic['get']>>
  ): Promise<AxiosResponse<GetResponse<T>>> {
    return this.axios.get(path, ...args);
  }

  async post<T extends PostRoutePaths>(
    path: T,
    data: PostRouteRequest<T>,
    ...args: Tail<Tail<Parameters<AxiosStatic['post']>>>
  ): Promise<AxiosResponse<PostResponse<T>>> {
    return this.axios.post(path, data, ...args);
  }
}

export default ServerCaller;
